"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_METRICS_NAME = 'CSM_METRICS_PROVIDER';
//# sourceMappingURL=constants.js.map